export default async function (context) {
    if (context.$auth.strategy.refreshToken.status().expired() && process.client) {
        await context.$auth.logout()
        return       
    }

    context.redirect('/Dashboard')
}
